module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 _.each(Locum.pensionSchemes[scheme], function(field, fieldname) { ;
__p += '\n<div class="full-input">\n    ';
 if (field.type == 'text') { ;
__p += '\n        <label class="sr-only" for="' +
__e( fieldname ) +
'">' +
__e( field.placeholder ) +
'</label>\n        <input name="' +
__e( fieldname ) +
'" placeholder="' +
__e( field.placeholder ) +
'" type="text">\n    ';
 } ;
__p += '\n    ';
 if (field.type == 'select') { ;
__p += '\n        <div class="select">\n            <label class="sr-only" for="' +
__e( fieldname ) +
'">' +
__e( field.placeholder ) +
'</label>\n            <select name="' +
__e( fieldname ) +
'">\n                ';
 if (!Locum[fieldname]) { ;
__p += '\n                    <option disabled selected value="">' +
__e( field.placeholder ) +
'</option>\n                ';
 } ;
__p += '\n                ';
 _.each(field.options, function(option, val) { ;
__p += '\n                    <option\n                        value="' +
__e( val ) +
'"\n                        ';
 if (Locum[fieldname] && Locum[fieldname].selected == val) { ;
__p += '\n                        selected="selected"\n                        ';
 } ;
__p += '\n                    >\n                        ' +
__e( option ) +
'\n                    </option>\n                ';
 }); ;
__p += '\n            </select>\n        </div>\n    ';
 } ;
__p += '\n    ';
 if (field.tooltip) { ;
__p += '\n        <div class="tooltip-item" title="' +
__e( field.tooltip ) +
'">\n            <div class="i">\n                <i class="fa fa-info-circle"></i>\n            </div>\n        </div>\n    ';
 } ;
__p += '\n</div>\n';
 }); ;
__p += '\n\n\n';

}
return __p
};
